export const categories = [
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', color: 'bg-primary-100 text-primary-700', count: 12860 },
  { slug: 'shenghuo', name: '生活', icon: 'ri-home-heart-line', color: 'bg-accent-100 text-accent-700', count: 9540 },
  { slug: 'caiyi', name: '才艺', icon: 'ri-music-line', color: 'bg-secondary-100 text-secondary-700', count: 7230 },
  { slug: 'meishi', name: '美食', icon: 'ri-restaurant-line', color: 'bg-primary-100 text-primary-700', count: 6150 },
  { slug: 'lvyou', name: '旅游', icon: 'ri-earth-line', color: 'bg-accent-100 text-accent-700', count: 5280 },
  { slug: 'keji', name: '科技', icon: 'ri-smartphone-line', color: 'bg-secondary-100 text-secondary-700', count: 4890 },
  { slug: 'yinyue', name: '音乐', icon: 'ri-headphone-line', color: 'bg-primary-100 text-primary-700', count: 7650 },
  { slug: 'youxi', name: '游戏', icon: 'ri-gamepad-line', color: 'bg-accent-100 text-accent-700', count: 8320 },
];

export const features = [
  {
    icon: 'ri-flashlight-line',
    title: '海量精彩内容',
    description: '每日更新数万条高清短视频，搞笑、生活、才艺、美食、旅游等多元内容一网打尽，满足你的每一种兴趣需求。',
  },
  {
    icon: 'ri-download-cloud-line',
    title: '一键下载分享',
    description: '支持高清视频一键下载到本地，随时离线观看。更可快速分享至微信、微博、QQ等社交平台，与好友一起分享快乐。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '智能个性推荐',
    description: '基于先进的AI算法，精准分析你的观看偏好，为你推荐最合口味的视频内容，越用越懂你。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全绿色平台',
    description: '严格的内容审核机制，打造健康积极的短视频社区。多重隐私保护措施，让你安心享受短视频带来的乐趣。',
  },
];

export const reviews = [
  {
    name: '小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20with%20warm%20smile%2C%20casual%20style%2C%20clean%20simple%20background%2C%20natural%20lighting%2C%20professional%20headshot%20photography%2C%20friendly%20expression&width=120&height=120&seq=avatar-01&orientation=squarish',
    rating: 5,
    comment: '快猫视频真的太好玩了！每天刷到停不下来，内容超级丰富，搞笑视频让我笑得合不拢嘴，强烈推荐给所有朋友！',
  },
  {
    name: '小李',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20gentle%20smile%2C%20modern%20casual%20outfit%2C%20clean%20minimalist%20background%2C%20soft%20natural%20studio%20lighting%2C%20professional%20headshot&width=120&height=120&seq=avatar-02&orientation=squarish',
    rating: 5,
    comment: '自从用了快猫视频，碎片时间再也不无聊了。AI推荐特别准，总能刷到我喜欢的才艺和美食视频，下载功能也很方便。',
  },
  {
    name: '老张',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%20with%20confident%20expression%2C%20business%20casual%20style%2C%20clean%20simple%20background%2C%20warm%20natural%20lighting%2C%20professional%20headshot&width=120&height=120&seq=avatar-03&orientation=squarish',
    rating: 4,
    comment: '快猫视频的内容质量很高，没有低俗内容。我经常在上面学习生活小技巧和美食制作，收获满满，真的是良心平台。',
  },
  {
    name: '小美',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20bright%20smile%2C%20fashionable%20casual%20style%2C%20clean%20light%20background%2C%20soft%20natural%20studio%20lighting%2C%20professional%20headshot%20photography&width=120&height=120&seq=avatar-04&orientation=squarish',
    rating: 5,
    comment: '界面简洁好用，不像其他平台那么多广告。旅游类视频特别赞，足不出户就能看遍世界美景，已经安利给身边所有闺蜜啦！',
  },
  {
    name: '大刘',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20in%20his%20thirties%20portrait%2C%20friendly%20expression%2C%20casual%20hoodie%20style%2C%20clean%20minimalist%20background%2C%20warm%20studio%20lighting%2C%20professional%20headshot&width=120&height=120&seq=avatar-05&orientation=squarish',
    rating: 5,
    comment: '快猫视频的下载速度非常快，而且画质清晰。通勤路上离线看视频，流量也不用愁，已经是我手机里的必备App了。',
  },
];

export const stats = [
  { label: '注册用户', value: '5000万+', icon: 'ri-user-line' },
  { label: '每日视频更新', value: '10万+', icon: 'ri-video-line' },
  { label: '累计下载量', value: '2亿+', icon: 'ri-download-line' },
  { label: '平均日活用户', value: '3000万+', icon: 'ri-fire-line' },
];

export const hotArticles = [
  {
    slug: 'duanshipin-qushi-2026',
    title: '2026年短视频行业趋势分析：快猫视频引领新风潮',
    excerpt: '随着移动互联网的持续发展，短视频行业在2026年迎来了新一轮变革。快猫视频凭借其独特的内容生态和AI推荐算法...',
    category: '科技',
    date: '2026-07-28',
    image: 'https://readdy.ai/api/search-image?query=Modern%20tech%20office%20with%20abstract%20data%20visualization%20hologram%2C%20warm%20orange%20and%20gold%20accent%20lighting%2C%20minimalist%20workspace%2C%20futuristic%20clean%20aesthetic%2C%20soft%20ambient%20atmosphere%2C%20technology%20concept%20photography%20with%20shallow%20depth%20of%20field&width=800&height=450&seq=article-trend-01&orientation=landscape',
  },
  {
    slug: 'chuangzuozhe-jihua',
    title: '快猫视频创作者扶持计划全面升级，百万奖金等你来拿',
    excerpt: '为鼓励优质内容创作，快猫视频宣布创作者扶持计划全面升级。新计划将为创作者提供更高的分成比例和流量支持...',
    category: '平台动态',
    date: '2026-07-25',
    image: 'https://readdy.ai/api/search-image?query=Creative%20workspace%20with%20warm%20golden%20lighting%2C%20content%20creator%20filming%20setup%20with%20ring%20light%2C%20modern%20minimalist%20studio%2C%20orange%20and%20amber%20color%20palette%2C%20professional%20aesthetic%2C%20soft%20atmospheric%20mood&width=800&height=450&seq=article-creator-02&orientation=landscape',
  },
  {
    slug: 'shipin-bianji-jiqiao',
    title: '短视频剪辑入门：快猫视频教你轻松制作爆款内容',
    excerpt: '想在快猫视频上发布自己的作品却不知道如何剪辑？本文为你整理了从零开始的短视频剪辑技巧，助你快速上手...',
    category: '教程',
    date: '2026-07-20',
    image: 'https://readdy.ai/api/search-image?query=Video%20editing%20workstation%20with%20monitor%20displaying%20timeline%2C%20warm%20ambient%20lighting%2C%20minimalist%20desk%20setup%2C%20creative%20professional%20environment%2C%20orange%20and%20warm%20neutral%20tones%2C%20modern%20aesthetic%20photography&width=800&height=450&seq=article-edit-03&orientation=landscape',
  },
];

export const faqs = [
  {
    question: '快猫视频怎么下载？',
    answer: '您可以通过官方网站直接下载快猫视频App。支持iOS和Android双平台，扫描首页二维码或在应用商店搜索"快猫视频"即可免费下载安装。',
  },
  {
    question: '快猫视频收费吗？',
    answer: '快猫视频是一款完全免费的短视频娱乐平台。观看视频、下载内容、分享互动等核心功能全部免费，无需任何付费即可畅享海量精彩内容。',
  },
  {
    question: '如何在快猫视频上发布自己的作品？',
    answer: '下载并注册快猫视频App后，点击底部发布按钮，即可拍摄或上传您的视频作品。平台提供丰富的滤镜、特效和剪辑工具，帮助您轻松创作优质内容。',
  },
  {
    question: '快猫视频支持离线观看吗？',
    answer: '当然支持！快猫视频提供一键下载功能，您可以将喜欢的视频下载到本地，随时随地离线观看，无需消耗流量。',
  },
  {
    question: '快猫视频的最新版本有什么新功能？',
    answer: '快猫视频最新版优化了AI推荐算法，新增了4K超清播放模式，升级了视频编辑工具，同时提升了App的整体运行速度和稳定性，带来更流畅的使用体验。',
  },
];